import React from 'react';
import type { V1QuestionOption } from '../types/v1-questionnaire.types';
import { V1CardOption } from './V1CardOption';

interface V1CheckboxQuestionProps {
  options: V1QuestionOption[];
  value: string[];
  onChange: (value: string[]) => void;
  hasError?: boolean;
  primaryColor?: string;
}

export const V1CheckboxQuestion: React.FC<V1CheckboxQuestionProps> = ({
  options,
  value,
  onChange,
  hasError = false,
  primaryColor = '#3B82F6',
}) => {
  const handleToggle = (optionId: string) => {
    if (value.includes(optionId)) {
      onChange(value.filter(id => id !== optionId));
    } else {
      onChange([...value, optionId]);
    }
  };

  const sortedOptions = options.sort((a, b) => a.position - b.position);
  const useCards = sortedOptions.length <= 4;

  if (useCards) {
    return (
      <div className={`grid grid-cols-1 gap-3 ${hasError ? 'p-3 border-2 border-red-500 rounded-lg' : ''}`}>
        {sortedOptions.map((option) => (
          <V1CardOption
            key={option.id}
            option={option.text}
            optionId={option.id}
            selected={value.includes(option.id) || value.includes(option.value)}
            onClick={() => handleToggle(option.id)}
            type="checkbox"
            primaryColor={primaryColor}
          />
        ))}
      </div>
    );
  }

  // Regular checkbox list for more than 4 options
  return (
    <div className={`space-y-2 ${hasError ? 'p-3 border-2 border-red-500 rounded-lg' : ''}`}>
      {sortedOptions.map((option) => {
        const isChecked = value.includes(option.id) || value.includes(option.value);
        
        return (
          <div 
            key={option.id} 
            className="flex items-center cursor-pointer p-2 rounded hover:bg-gray-50"
            onClick={() => handleToggle(option.id)}
          >
            <input
              type="checkbox"
              id={`checkbox-${option.id}`}
              value={option.value}
              checked={isChecked}
              onChange={() => {}} // Handle change through parent div click
              className="h-4 w-4 border-gray-300 rounded pointer-events-none"
              style={{ accentColor: primaryColor }}
            />
            <label
              htmlFor={`checkbox-${option.id}`}
              className="ml-2 text-sm text-gray-700 cursor-pointer flex-1"
            >
              {option.text}
            </label>
          </div>
        );
      })}
    </div>
  );
};